import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.color || colors.blue_main;

  return (
    <svg width="21" height="22" fill="none" viewBox="0 0 21 22">
      <path
        fill={color}
        d="M17.65 0a3.324 3.324 0 00-2.369.982l-2.437 2.435-7.406-1.645a.875.875 0 00-.676.125l-2.625 1.75a.875.875 0 00.048 1.488l5.688 3.25-2.021 2.023-3.01-.755a.875.875 0 00-.832.23l-1.75 1.75a.875.875 0 00.219 1.402l4.988 2.499 2.494 4.99a.875.875 0 00.648.48.991.991 0 00.14 0 .875.875 0 00.619-.257l1.75-1.75a.876.876 0 00.23-.838l-.755-3.02 2.021-2.012 3.252 5.688a.876.876 0 00.728.438h.03a.877.877 0 00.73-.39l1.75-2.625a.873.873 0 00.124-.676l-1.645-7.406 2.435-2.437A3.349 3.349 0 0017.651 0zM4.286 4.319l1.138-.757 5.955 1.312-2.218 2.23-4.875-2.785zM17.44 15.577l-.757 1.138-2.785-4.874 2.22-2.215 1.322 5.951zm1.343-11.094l-9.777 9.775a.874.874 0 00-.23.838l.755 3.02-.54.535-2.084-4.157a.893.893 0 00-.391-.391L2.358 12.02l.542-.54 3.004.746a.875.875 0 00.832-.23l9.781-9.778a1.602 1.602 0 012.265 2.265z"></path>
    </svg>
  );
}

export default Icon;
